// initial state
const state = () => ({
  showOrder: window?.location?.hash === '#objednavka' ? true : false
})

// functionName: (state, getters, rootState) => {}
const getters = {

}

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  showOrder ({ commit }) {
    commit('showOrder')
  },
}

// functionName (state, { param, ... }) {
const mutations = {
  showOrder (state) {
    state.showOrder = true
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
